var map = {
	"./adult/nn/3 01 Tulleord Intro.mp3": 758,
	"./adult/no/3 01 Tulleord Intro.mp3": 759,
	"./adult/se/3 01 Tulleord Intro.mp3": 760,
	"./youth/de/3 01 Tulleord Intro.mp3": 761,
	"./youth/nn/3 01 Tulleord Intro.mp3": 762,
	"./youth/no/3 01 Tulleord Intro.mp3": 763,
	"./youth/se/3 01 Tulleord Intro.mp3": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;